import { ConsoleInterface } from '../types/Console';
import Author from './author';
import Flows from './flows';
import Knowledge from './knowledge';
import Prompts from './prompts';

export class Client implements ConsoleInterface {
  flows: Flows;
  knowledge: Knowledge;
  author: Author;
  prompts: Prompts;

  constructor({ apiKey }: { apiKey: string }) {
    this.flows = new Flows(apiKey);
    this.knowledge = new Knowledge(apiKey);
    this.author = new Author(apiKey);
    this.prompts = new Prompts(apiKey);
  }
}

export default Client;
